/**
 * The BroadcastChannel name used for state communication between the
 * Service Worker StateManager and main-thread StateClient instances.
 */
export const STATE_CHANNEL_NAME = 'dabih-state';
